module.exports = __webpack_public_path__ + "static/media/participles0_img.2708b7ad.JPG";